import { ref, type Ref } from 'vue';
import { IDashboardOverrides } from '@/interfaces/powerMarkets/dashboard/IDashboard.ts';

function hasActiveDateObjectOverride (dateObject: IDashboardOverrides['chart'] | null | undefined): boolean {
    return !!(
        dateObject?.from
        || dateObject?.to
        || dateObject?.aggregateOptions
        || dateObject?.timezone
        || dateObject?.periodsPerDay
    );
}

export function hasActiveDashboardOverride (dateOverrideToSet: IDashboardOverrides | null | undefined): boolean {
    return !!(
        hasActiveDateObjectOverride(dateOverrideToSet?.chart)
        || hasActiveDateObjectOverride(dateOverrideToSet?.hof)
        || dateOverrideToSet?.boa
        || (dateOverrideToSet?.commonSettings && Object.values(dateOverrideToSet.commonSettings).some(Boolean))
    );
}

export function usePlantDateOverride (): {
    explicitPlantDateOverride: Ref<IDashboardOverrides | undefined>;
    updateDashboardDatesOverride: (dateOverrideToSet: IDashboardOverrides | undefined) => void;
    resetPlantDateOverride: () => void;
} {
    const explicitPlantDateOverride = ref<IDashboardOverrides | undefined>(undefined);

    function updateDashboardDatesOverride (dateOverrideToSet: IDashboardOverrides | undefined): void {
        explicitPlantDateOverride.value = hasActiveDashboardOverride(dateOverrideToSet)
            ? dateOverrideToSet
            : undefined;
    }

    function resetPlantDateOverride (): void {
        explicitPlantDateOverride.value = undefined;
    }

    return {
        explicitPlantDateOverride,
        updateDashboardDatesOverride,
        resetPlantDateOverride,
    };
}
